import LoginPage from '../pages/login-page';
import HomePage from '../pages/home-page';
import DashboardLayout from '../layout/dashboard-layout';
import SelectVenuePage from '../pages/select-venue';

import MobileAboutUsPage from '../pages/mobile-about-us/mobile-about-us-page';
import MobileBannersPage from '../pages/mobile-banners/mobile-banners-page';
import AnalyticsPage from '../pages/analytics/analytics-page';
import GeoAnalyticsPage from '../pages/geo-analytics/geo-analytics-page';
import PlayerCommunicationsPage from '../pages/player-communications/player-communications-page';
import FenceVenueConfigPage from '../pages/fence-venue-config/fence-venue-config-page';
import FenceConfigPage from '../pages/fence-config/fence-config-page';
import KioskHealthPage from '../pages/kiosk-health/kiosk-health-page';
import CreateKioskAttractorPage from '../pages/kiosk-attractor/create-kiosk-attractor-page';
import MobileAttractorPage from '../pages/mobile-attractor/mobile-attractor-page';
import CreateAboutLinkPage from '../pages/mobile-about-us/create-about-link-page';
import CreateMobileBannerPage from '../pages/mobile-banners/create-mobile-banner-page';
import CreateMobileAttractorPage from '../pages/mobile-attractor/create-mobile-attractor-page';
import kioskAttractorPage from '../pages/kiosk-attractor/kiosk-attractor-page';
import KioskAttractorCampaignsPage from '../pages/kiosk-attractor-campaigns/kiosk-attractor-campaigns-page';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import ScheduledNotificationsPage from '../pages/scheduled-notifications/ScheduledNotificationsPage';
import VenueSetupStatusPage from '../pages/venue-setup-status-page';
import { isProductionUrl } from '../utilities';

const RouterProvider = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" />} />

      <Route path="/login" Component={LoginPage} />

      <Route
        element={
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        }
      >
        <Route path="/venue-setup-status" Component={VenueSetupStatusPage} />
        <Route
          path="/player-communications"
          Component={PlayerCommunicationsPage}
        />
        <Route
          path="/scheduled-communications"
          Component={ScheduledNotificationsPage}
        />
        <Route path="/mobile-attractors" Component={MobileAttractorPage} />
        <Route
          path="/mobile-attractors/create"
          Component={CreateMobileAttractorPage}
        />
        <Route path="/mobile-banners" Component={MobileBannersPage} />
        <Route
          path="/mobile-banners/create"
          Component={CreateMobileBannerPage}
        />
        <Route path="/kiosk-attractors" Component={kioskAttractorPage} />
        <Route
          path="/kiosk-attractors/create"
          Component={CreateKioskAttractorPage}
        />
        {/*
          The kit rebuild of the page above, served alongside it for staging review. It is not
          released, so production sends this URL to the current page instead.
        */}
        <Route
          path="/kiosk-attractors-1"
          element={
            isProductionUrl() ? (
              <Navigate to="/kiosk-attractors" replace />
            ) : (
              <KioskAttractorCampaignsPage />
            )
          }
        />
        <Route path="/mobile-about-us" Component={MobileAboutUsPage} />
        <Route path="/mobile-about-us/create" Component={CreateAboutLinkPage} />
        <Route path="/analytics" Component={AnalyticsPage} />
        <Route path="/geo-analytics" Component={GeoAnalyticsPage} />
        <Route path="/fence-config" Component={FenceConfigPage} />
        <Route path="/fence-venue-config" Component={FenceVenueConfigPage} />
        <Route path="/kiosk-health" Component={KioskHealthPage} />
        <Route path="/select-venue" Component={SelectVenuePage} />
        <Route path="/home" Component={HomePage} />
      </Route>
      <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
  );
};
export default RouterProvider;
